import { PropsWithChildren } from "react"

import { join } from "@/utils/join"

import { PriceButtonVariant } from "./types"

interface SymbolProps {
  variant: PriceButtonVariant
}

export const PriceButtonSymbol = ({
  variant,
  ...props
}: PropsWithChildren<SymbolProps>) => {
  const className = "symbol text-2xs-regular"

  const classes: Record<typeof variant, string> = {
    primary: "text-tertiary",
    pending: "",
    priceAnnounced: "text-white",
    disabled: "text-disabled",
    active: "text-white",
  }

  return <p className={join(className, classes[variant])} {...props} />
}
